/**
 * creates a promise to sleep the given milliseconds
 *
 * @export
 * @param {number} [milliseconds=0]
 * @returns
 */
export function sleep(milliseconds = 0): Promise<void> {
  return new Promise<void>((resolve): number =>
    window.setTimeout(resolve, milliseconds)
  );
}

export async function postRaw<Q, R>(
  endpointURL: string,
  parameters: Q
): Promise<R> {
  const request = {
    body: JSON.stringify(parameters),
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
  };

  let retries = 0;
  do {
    try {
      const response = await fetch(endpointURL, request);
      if (
        response.ok && 
        response.headers.get('content-type') === 'application/json'
      ) {
        return await response.json();
      }
    } catch (e) {}
    await sleep(1000);
  } while (++retries < 10);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return {} as any;
}

export async function postFormData<Q, R>(
  url: string,
  parameters: Q
): Promise<R | undefined> {
  const formdata = new FormData();
  formdata.append('json', JSON.stringify(parameters));
  const request = {
    method: 'POST',
    body: formdata,
  };

  try {
    const response = await fetch(url, request);
    if (
      response.ok && 
      response.headers.get('content-type') === 'application/json'
    ) {
      return await response.json();
    }
  } catch {}
}
